import { useEffect, useRef } from "react";
import { Bold, Italic, List, ListOrdered, Quote, Link2, Heading2, Heading3, RemoveFormatting } from "lucide-react";

const exec = (cmd, val = null) => document.execCommand(cmd, false, val);

export const RichTextEditor = ({ value, onChange, placeholder = "Write your post..." }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sync = () => onChange(ref.current.innerHTML);

  const Btn = ({ label, icon: Icon, onClick, testId }) => (
    <button
      type="button"
      title={label}
      aria-label={label}
      data-testid={testId}
      onMouseDown={(e) => { e.preventDefault(); onClick(); sync(); }}
      className="p-2 hover:bg-[#F3F4F6] text-[#3A4A63] hover:text-[#041C3E] transition-colors"
    >
      <Icon size={16} />
    </button>
  );

  const addLink = () => {
    const url = window.prompt("Link URL (https://...)");
    if (url) exec("createLink", url);
  };

  return (
    <div className="border border-[#E5E7EB]" data-testid="blog-editor">
      <div className="flex flex-wrap items-center gap-0.5 border-b border-[#E5E7EB] bg-white px-1 py-1">
        <Btn label="Heading" icon={Heading2} testId="blog-editor-h2" onClick={() => exec("formatBlock", "h2")} />
        <Btn label="Subheading" icon={Heading3} testId="blog-editor-h3" onClick={() => exec("formatBlock", "h3")} />
        <span className="w-px h-5 bg-[#E5E7EB] mx-1" />
        <Btn label="Bold" icon={Bold} testId="blog-editor-bold" onClick={() => exec("bold")} />
        <Btn label="Italic" icon={Italic} testId="blog-editor-italic" onClick={() => exec("italic")} />
        <span className="w-px h-5 bg-[#E5E7EB] mx-1" />
        <Btn label="Bulleted list" icon={List} testId="blog-editor-ul" onClick={() => exec("insertUnorderedList")} />
        <Btn label="Numbered list" icon={ListOrdered} testId="blog-editor-ol" onClick={() => exec("insertOrderedList")} />
        <Btn label="Quote" icon={Quote} testId="blog-editor-quote" onClick={() => exec("formatBlock", "blockquote")} />
        <Btn label="Link" icon={Link2} testId="blog-editor-link" onClick={addLink} />
        <span className="w-px h-5 bg-[#E5E7EB] mx-1" />
        <Btn label="Clear formatting" icon={RemoveFormatting} testId="blog-editor-clear"
             onClick={() => { exec("removeFormat"); exec("formatBlock", "p"); }} />
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        data-testid="blog-editor-body"
        data-placeholder={placeholder}
        onInput={sync}
        onBlur={sync}
        className="blog-prose blog-editable min-h-[280px] max-h-[540px] overflow-auto px-4 py-3 outline-none"
      />
    </div>
  );
};
